/**
 * gamesConstants.js
 *
 * Именованные числа для layout раздела «Игры».
 * Зачем: вместо screenWidth - 260 в коде — понятное имя и одно место правки под Figma.
 */

/** Ширина экрана, ниже которой заголовок «Игры» уменьшается */
export const GAMES_PAGE_TITLE_BREAKPOINT = 720;

/** Ширина контентной колонки: переключение узкий/широкий sidebar */
export const GAMES_CONTENT_WIDE_BREAKPOINT = 1400;

/** Вычитаем из screenWidth на desktop — sidebar + отступы (узкий layout) */
export const GAMES_CONTENT_OFFSET_NARROW = 260;

/** Вычитаем из screenWidth на desktop — sidebar + отступы (широкий layout) */
export const GAMES_CONTENT_OFFSET_WIDE = 300;

/** Высота featured-баннера на desktop */
export const GAMES_BANNER_HEIGHT = 320;

/** Скругление баннера и крупных карточек */
export const GAMES_BORDER_RADIUS_LG = 20;

/** Скругление плиток в сетке */
export const GAMES_BORDER_RADIUS_MD = 16;

/** Мин/макс ширина плитки в grid */
export const GAMES_TILE_MIN_WIDTH = 140;
export const GAMES_TILE_MAX_WIDTH = 220;

/** Отступы между блоками на странице */
export const GAMES_SECTION_GAP = 24;
export const GAMES_GRID_GAP = 16;
export const GAMES_MOBILE_GRID_GAP = 12;

/** Legacy mobile card — порог row/column layout в ViewGameBlock */
export const GAMES_MOBILE_CARD_ROW_BREAKPOINT = 580;
